<div class="flex flex-col h-full">
	<div class="flex flex-col gap-4">
		<div>
			<label class="p-sm">Template</label>
			<ui-select
				[options]="templateOptions_()"
				[selected]="selectedTemplateOption_()"
				(selectedChange)="onTemplateChange($event)"
			/>
		</div>
		<div class="flex flex-col gap-4">
			<div>
				<label class="p-sm">Subject</label>
				<input
					type="text"
					[(ngModel)]="subject_"
					class="p-sm px-3 py-2 rounded-md border border-gray-200 w-full focus:outline-green placeholder:text-gray-500"
				/>
			</div>
			<div class="flex flex-col gap-2">
				<div>
					<div class="flex items-center justify-between gap-2">
						<label class="p-sm">To</label>
						<div class="p-sm cursor-pointer" (click)="toggleCc()">CC Bcc</div>
					</div>
					<ui-select
						[options]="viewModel_().clientEmailOptions"
						[(selected)]="to_"
						[mode]="'multi'"
						[searchable]="true"
						[allowCustom]="true"
						[customValueValidator]="isValidEmail"
						[placeholder_]="'Add email addresses...'"
					/>
				</div>
				@if (showCc_()) {
					<div>
						<label class="p-sm">CC</label>
						<ui-select
							[options]="viewModel_().clientEmailOptions"
							[(selected)]="cc_"
							[mode]="'multi'"
							[searchable]="true"
							[allowCustom]="true"
							[customValueValidator]="isValidEmail"
							[placeholder_]="'Add CC email addresses...'"
						/>
					</div>
					<div>
						<label class="p-sm">BCC</label>
						<ui-select
							[options]="viewModel_().clientEmailOptions"
							[(selected)]="bcc_"
							[mode]="'multi'"
							[searchable]="true"
							[allowCustom]="true"
							[customValueValidator]="isValidEmail"
							[placeholder_]="'Add BCC email addresses...'"
						/>
					</div>
				}
			</div>
			<app-email-template-editor
				[tagOptions]="viewModel_().tagOptions"
				[(content)]="content_"
			></app-email-template-editor>

			<!-- EXCLUSIVELY FOR E2E TESTS, PLEASE DO NOT REMOVE IT -->
			<div
				[testHook]="testHooks.ClientIntakeURL"
				class="invisible"
				aria-hidden="true"
			>
				{{ clientIntakeUrl_() }}
			</div>

			<div class="grid grid-cols-2 gap-2 mt-2">
				@for (attachment of attachments_(); track attachment.fileName) {
					<!-- <app-email-attachment
						[attachmentName]="attachmentName"
						(remove)="removeAttachment()"
					></app-email-attachment> -->
					<!-- TODO USE app-email-attachment component, and fix ref issues with  drawer-->
					<div
						class="flex border border-grey-lighter justify-center items-center gap-2 p-2 rounded-md hover:cursor-pointer hover:bg-gray-100 duration-300"
					>
						<div
							class="bg-pdfDocumentRed text-white size-8 flex items-center justify-center rounded-md flex-shrink-0"
						>
							<i-tabler name="file-type-pdf"></i-tabler>
						</div>

						<span
							class="flex-1 text-ellipsis overflow-hidden whitespace-nowrap"
							>{{ attachment.fileName }}</span
						>
						<app-button
							btn="tertiary"
							[holdable]="true"
							[icon]="ICON.DELETE"
						></app-button>
					</div>
				}
			</div>
		</div>
	</div>
</div>
